export const ALPHANUMERIC_REG_EXP = /[a-zA-Z0-9]+/g;
export const ALPHANUMERIC_INPUT_PATTERN = '[a-zA-Z0-9]+';
export const ALPHANUMERIC_INPUT_PATTERN_LENGTH_2 = '^[a-zA-Z0-9]{1,2}$';
export const NUMERIC_INPUT_PATTERN_LENGTH_3 = '^[0-9]{1,3}$';
export const ALPHANUMERIC_WITH_SPACE_INPUT_PATTERN = '[a-zA-Z0-9\\s]+';
export const ALPHANUMERIC_WITH_DIACRITICS_INPUT_PATTERN = '[a-zA-Z0-9À-ž]+';
